<template>
  <div class="assist-operation-choose-sn">
    <div class="machines-list-scan">
      <search-scan
        @getValue="getValue"
        placeholder="请输入机具编号"
        ref="search-scan"
      ></search-scan>
    </div>
    <div
      v-if="lastBindSn.snCode"
      class="original-binding"
      v-clipboard:copy="lastBindSn.snCode"
      v-clipboard:success="copySuccess"
      v-clipboard:error="copyFail"
    >
      店铺原绑定机具号：
      <span class="sn">{{ lastBindSn.snCode || '' }}</span>
      <img
        class="copy"
        src="@/assets/img/assist-operation/icon_copy_red.png"
        alt
      />
    </div>
    <div v-if="lastBindSn && lastBindSn.policyType" class="original-binding">
      原绑定机具类型：
      <span class="sn">
        {{ lastBindSn.upstream || '-' }}&nbsp;&nbsp;{{ lastBindSn.policyType }}
      </span>
    </div>
    <div class="statistics-menu">
      <div class="left">共{{ count }}台</div>
    </div>
    <div class="list-title">
      <div class="id">机具编号</div>
      <div class="id">机具类型</div>
      <div class="operation">操作</div>
    </div>
    <div
      class="wrap"
      ref="listwrap"
      :style="{ height: listwrapH, overflow: 'scroll' }"
    >
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <div class="no-found" v-if="!list || list.length == 0">
          <img src="@/assets/img/img-nofound.png" />
          <div class="txt">没有更多了哦~</div>
        </div>
        <van-list
          v-else
          class="list"
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            v-for="(item, index) in list"
            :key="index"
            class="list-item"
            :class="{
              highlight: item.snCode == lastBindSn.snCode
            }"
          >
            <div
              class="content"
              :class="{ 'border-bottom': index + 1 < list.length }"
            >
              <div
                class="number"
                @click.stop
                v-clipboard:copy="item.snCode"
                v-clipboard:success="copySuccess"
                v-clipboard:error="copyFail"
              >
                <div class="start has-product-label">
                  <channelTag :model="item.upstream" />
                  {{ item.snCode }}
                  <img
                    class="copy"
                    src="@/assets/img/assist-operation/icon_copy_red.png"
                    alt
                  />
                </div>
              </div>
              <div>{{ item.policyType }}</div>
              <div
                class="operation"
                v-show="isSelected(item.snCode)"
                @click.stop="select(item.snCode)"
              >
                <img src="@/assets/img/assist-operation/icon_plus.png" />
              </div>
              <div
                class="operation"
                v-show="!isSelected(item.snCode)"
                @click.stop="clean(item.snCode)"
              >
                <img src="@/assets/img/assist-operation/icon_minus.png" />
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <div ref="fixedBottom" class="custom-button fixed">
      <div class="btn" :class="{ active: selectList.length }" @click="submit">
        下一步
      </div>
    </div>
    <confirm-dialog
      v-if="showConfirmDialog"
      confirmText="继续"
      content="非原店铺绑定的机具，是否继续绑定？"
      @close="showConfirmDialog = false"
      @submit="toAssistOperationPage"
    ></confirm-dialog>
  </div>
</template>

<script>
import searchScan from '@/views/biz-components/assist-operation/search-scan.vue'
import ConfirmDialog from '@/views/biz-components/assist-operation/confirm-dialog'
import channelTag from '@/views/components/channel-tag.vue'
import { storeAssistEntryGetMachineList } from '@/api/assist-operation'
export default {
  components: {
    searchScan,
    ConfirmDialog,
    channelTag
  },
  data() {
    return {
      showConfirmDialog: false,
      count: 0,
      listwrapH: '',
      refreshing: false,
      loading: false,
      finished: false,
      showPopup: false,
      lastBindSn: '',
      list: [],
      selectList: [],
      keyWord: '',
      assistEntryId: this.$route.query.assistEntryId,
      pageNum: 0,
      pageSize: 50,
      scrollTop: 0
    }
  },
  computed: {
    isSelected() {
      return val => {
        if (!this.selectList.includes(val)) {
          return true
        }
        return false
      }
    }
  },
  created() {
    this.onLoad()
  },
  mounted() {
    this.getListwrapH()
  },
  methods: {
    getListwrapH() {
      this.$nextTick(() => {
        let fixedBottomH = this.$refs.fixedBottom.offsetHeight
        let listwrapT = this.$refs.listwrap.getBoundingClientRect().top
        this.listwrapH = `calc(100vh - ${listwrapT}px - ${fixedBottomH}px)`
      })
    },
    copySuccess() {
      this.$toast('复制成功')
    },
    copyFail() {
      this.$toast('复制失败')
    },
    queryList() {
      let params = {
        action: 'storeAssistEntryGetMachineList',
        assistEntryId: this.assistEntryId,
        searchSn: this.keyWord,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      console.log(params)
      storeAssistEntryGetMachineList({ ...params }).then(res => {
        console.log(res)
        this.getListwrapH()
        this.loading = false
        this.lastBindSn = res.lastBindSn || {}
        this.count = res.totalCount
        this.list = this.list.concat(res.snList)
        if (res.lastBindSn && res.lastBindSn.snCode) {
          let isHightLight = this.list.filter(item => {
            return item.snCode == res.lastBindSn.snCode
          })
          if (isHightLight.length) {
            this.selectList.push(res.lastBindSn.snCode)
            this.moveItemToFirst(this.list, res.lastBindSn)
          }
        }
        if (res.snList.length < this.pageSize) {
          this.finished = true
        }
      })
    },
    async getValue(val) {
      this.finished = false
      this.keyWord = val
      this.selectList = []
      this.list = []
      this.queryList()
    },
    select(sn) {
      this.selectList = []
      this.selectList.push(sn)
    },
    clean(sn) {
      this.selectList.splice(
        this.selectList.findIndex(item => item === sn),
        1
      )
    },
    onRefresh() {
      this.finished = false
      this.pageNum = 1
      this.list = []
      this.selectList = []
      this.queryList()
      setTimeout(() => {
        this.refreshing = false
      }, 1000)
    },
    onLoad() {
      this.pageNum++
      this.queryList()
    },
    close() {
      this.showPopup = false
    },
    reset() {
      this.keyWord = ''
      this.model = ''
      this.selectList = []
      this.finished = false
      this.$refs['search-scan'].value = ''
      try {
        this.$refs['list-filter'].reset()
      } catch (error) {}
    },
    submit() {
      if (!this.selectList.length) return
      // 如果选择的不是上次绑定过的机具则弹窗提醒
      if (this.lastBindSn && this.selectList[0] != this.lastBindSn.snCode)
        return (this.showConfirmDialog = true)
      this.showConfirmDialog = false
      this.toAssistOperationPage()
    },
    toAssistOperationPage() {
      this.$router.push({
        name: 'assist-operation',
        query: {
          model: this.model,
          assistEntryId: this.$route.query.assistEntryId,
          snCode: this.selectList[0]
        }
      })
    },
    moveItemToFirst(arr, item) {
      let fromIndex
      arr.filter((element, index) => {
        if (element.snCode == item.snCode) {
          fromIndex = index
        }
      })
      let tpl
      for (let i = 0; i < arr.length; i++) {
        tpl = arr[i]
        if (i === fromIndex) {
          arr.splice(i, 1)
          break
        }
      }
      arr.unshift(tpl)
    }
  }
}
</script>
